export const TITLE_BAR_HEIGHT = 128;
export const TITLE_BAR_MARGIN = 16;

export const TITLE_BAR_FONT_SIZE = 80;
